const pageName = { singular: 'Profile', plural: 'profile' }

export default [
  {
    path: '/setting-kompship/profile',
    alias: '/setting/profile',
    name: 'kompship-profile',
    component: () => import('@/views/pages/komship/setting-kompship/Profile'),
    meta: {
      name: pageName.singular,
      resource: 'Setting Komship',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/verification-ktp',
    name: 'verification-ktp',
    component: () => import('@/views/components/verification-ktp/Verification.vue'),
    meta: {
      resource: 'Setting Komship',
      action: 'manage',
      navActiveLink: 'kompship-profile',
    },
  },
]
